// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_nFLLL_eCWmVPDWOP1qp2TC16uUd1ok0",
  authDomain: "yoga-harmony.firebaseapp.com",
  databaseURL: "https://yoga-tana-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "yoga-tana",
  storageBucket: "yoga-tana.appspot.com",
  messagingSenderId: "753606645788",
  appId: "1:753606645788:web:5865b360f0ce19d00067d9",
  measurementId: "G-C9YGF53BJ8"
};

// Test config
// const firebaseConfig = {
//   apiKey: "AIzaSyAUCn8c9UsgMXFYPUSaQ90RiYojwI8wCnA",
//   authDomain: "yoga-harmony-test.firebaseapp.com",
//   databaseURL: "https://yoga-harmony-test-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "yoga-harmony-test",
//   storageBucket: "yoga-harmony-test.appspot.com",
//   messagingSenderId: "432603895146",
//   appId: "1:432603895146:web:8a4aa50a05ada842a44113",
//   measurementId: "G-507SLQ39DR"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyAUCn8c9UsgMXFYPUSaQ90RiYojwI8wCnA",
//   authDomain: "yoga-harmony-test.firebaseapp.com",
//   databaseURL: "https://yoga-harmony-test-default-rtdb.europe-west1.firebasedatabase.app",
//   projectId: "yoga-harmony-test",
//   storageBucket: "yoga-harmony-test.appspot.com",
//   messagingSenderId: "432603895146",
//   appId: "1:432603895146:web:8a4aa50a05ada842a44113",
//   measurementId: "G-507SLQ39DR"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
